import { HttpMethod } from '@nu-art/thunderstorm-shared';
export const ApiDef_ProviderChat = {
    sendPrompt: { method: HttpMethod.POST, path: '/chat-manager/send-prompt' },
};
//# sourceMappingURL=api-def.js.map